<template lang="pug" functional>
  .product-review-details
    p.date
      time(
        :datetime='props.date'
        v-text='$options.filters.formatDate(props.date)'
      )
    .info-section
      .author(
        itemprop='author'
        v-text='props.authorName'
      )
      .country(
        v-if='props.countryName'
        itemprop='country'
        v-text='props.countryName'
      )
    .common-label-container
      .staff-label-container(v-if='props.isStaff')
        img.common-label-icon.staff-icon(src='../../assets/images/icons/staff-label.svg')
        span.common-label-text.staff-label(v-t='"products.reviews.staffBadge"')

      .promotion-label-container(v-if='props.promotionLabel')
        img.common-label-icon.received-free-product-label(src='../../assets/images/icons/received-free-product-label.svg')
        span.common-label-text.promotion-label(
          itemprop='promotion'
          v-text='props.promotionLabel'
        )
</template>

<script>
import format from 'date-fns/format'
import parse from 'date-fns/parse'

export default {
  filters: {
    formatDate (date) {
      return format(parse(date), 'DD MMM YYYY')
    }
  },

  props: {
    date: {
      type: [Date, String],
      required: true
    },
    authorName: {
      type: String,
      required: true
    },
    countryName: {
      type: String,
      default: ''
    },
    isStaff: {
      type: Boolean,
      default: false
    },
    promotionLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .product-review-details {
    @include font-weight-book;
    font-size: 14px;
    color: $grey-dark;
    display: inline-flex;
    flex-wrap: wrap;

    @include media-breakpoint-up(sm) {
      display: block;
      line-height: 16px;
    }
  }

  .date {
    @include media-breakpoint-down(sm) {
      margin-right: 5px;
    }
  }

  .info-section {
    display: inline-flex;
    flex-wrap: wrap;
  }

  .author {
    margin-right: 5px;
    word-break: break-word;

    @include media-breakpoint-down(sm) {
      &::before {
        content: '•';
        margin-right: 5px;
      }
    }
  }

  .country {
    @include media-breakpoint-down(sm) {
      word-break: break-word;
    }

    &::before {
      content: '•';
      margin-right: 5px;
    }
  }

  .common-label-container {
    width: 100%;
    padding-top: 15px;

    .common-label-icon {
      height: 16px;
      width: 16px;
      vertical-align: middle;
    }

    .common-label-text {
      font-size: 14px;
      padding-left: 5px;
    }

    .promotion-label-container {
      padding-top: 10px;
    }
  }

  .received-free-product-label {
      height: 16px;
      width: 16px;
    }
</style>
